export default "__VITE_ASSET__b0b46423__"